import React from 'react';
import { useSelector } from 'react-redux';

import Dot from 'components/Dot';
import FeatureNotSupported from 'components/FeatureNotSupported';
import Message from 'components/Message';
import { Title } from 'features/App';
import { bem } from 'helpers/class-name';
import { IA_KEY } from 'helpers/ia-logic';
import { selectActiveVenue, selectIaLogic } from 'selectors/general';
import { selectIsMobile } from 'selectors/ui';

import HowSmartRateWorks from './HowSmartRateWorks';
import WeeklyEarnings from './WeeklyEarnings';
import SmartRateFaqs from './SmartRateFaqs';
import { useSmartRateFaqsQuery } from './SmartRate.hooks';
import messages from './SmartRate.messages';

import './SmartRate.scss';

const { element } = bem('smart-rate');

const SmartRate = () => {
  const isMobile = useSelector(selectIsMobile);
  const { venueId } = useSelector(selectActiveVenue);
  const { featureIsSupported } = useSelector(state => selectIaLogic(state, IA_KEY.SMART_RATE, venueId));
  const { data: faqs = [], isLoading } = useSmartRateFaqsQuery({
    enabled: featureIsSupported,
  });

  if (!featureIsSupported) {
    return <FeatureNotSupported />;
  }

  return (
    <>
      <Message message={messages.title} as={Title} />
      {isMobile ? (
        <>
          <div className={element('intro')}>
            <HowSmartRateWorks />
          </div>
          <div className={element('content-sheet')}>
            <WeeklyEarnings layout="embedded" />
            <SmartRateFaqs faqs={faqs} isLoading={isLoading} layout="embedded" />
          </div>
        </>
      ) : (
        <>
          <div className="smart-rate__status">
            <Dot color={Dot.COLORS.GREEN} />
            <Message message={messages.statusOn} />
          </div>
          <HowSmartRateWorks />
          <WeeklyEarnings layout="card" />
          <SmartRateFaqs faqs={faqs} isLoading={isLoading} layout="card" />
        </>
      )}
    </>
  );
};

export default SmartRate;
